
import { Vue, Component } from "vue-property-decorator";
// Entities
import { Company, Profile } from "@/entities/index";
import { getOrderedParts } from "@/services";

@Component
export default class RightCard extends Vue {
  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  warehouseCode = this.warehouse;
  integrateStepZero = this.company.integrateStepZero;

  orderedParts = 0;

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  get company(): Company {
    return this.$store.getters.company;
  }

  get warehouse(): string {
    return this.$store.getters.warehouse;
  }

  async getOrderedParts(): Promise<void> {
    const { orderedParts } = await getOrderedParts({
      client: this.client,
      warehouse: this.warehouse,
      integrateStepZero: this.integrateStepZero,
    });
    this.orderedParts = orderedParts;
  }
}
